import { IStatusesCount } from './interfaces';

const DEFAULT: IStatusesCount = {
  off: 0,
  on: 0,
  session: 0,
  booking: 0,
  highAccess: 0,
  service: 0,
  lostConnection: 0,
  shellOff: 0,
  locked: 0,
  configuration: 0,
};

const ICON_SIZE = 'm';

export { DEFAULT, ICON_SIZE };
